import React from "react";

// Typographic Delaboo wordmark with a small antler mark, matching brand poster.
export function BrandLogo({ dark = false, className = "", size = "text-3xl" }) {
  const teal = "#3f9c92";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <svg width="26" height="26" viewBox="0 0 64 64" fill="none" aria-hidden="true">
        <path d="M32 58c-7 0-12-5-12-12 0-5 3-8 3-8-6-2-10-8-10-8s5 1 8 0c-4-4-6-11-6-11s6 4 9 4c-2-4-1-11-1-11s4 6 6 8c0-4 0-9 0-9s2 5 3 8c1-3 3-8 3-8s0 5 0 9c2-2 6-8 6-8s1 7-1 11c3 0 9-4 9-4s-2 7-6 11c3 1 8 0 8 0s-4 6-10 8c0 0 3 3 3 8 0 7-5 12-12 12z"
          fill={teal} />
      </svg>
      <span className={`font-brand font-bold ${size} ${dark ? "text-brand-cream" : "text-brand-dark"}`}>
        delaboo
      </span>
    </div>
  );
}

export default BrandLogo;
